export enum PRACTICE_FEATURES {
  LOYALTY_PROGRAM = 'loyalty_program'
}
